var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social__content" },
    _vm._l(_vm.listEntries, function(entry) {
      return _c("p", { staticClass: "social__txt-icon-wrapper" }, [
        _c("a", { attrs: { href: entry.link, target: "_blank" } }, [
          _c("span", {
            staticClass: "social__icon-wrapper",
            domProps: { innerHTML: _vm._s(entry.icon) }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "social__txt" }, [
            _vm._v(_vm._s(entry.text))
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }